<template>
  <b-col class="d-table features-area h-100 pt-4">
    <b-row class="title d-table-row text-center">
      <span>{{ $t('profile.signUp.main.access') }}</span>
    </b-row>
    <b-row class="d-table-cell align-middle">
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="d-flex flex-column justify-content-around align-items-start h-50">
          <div class="d-flex item">
            <Icon :as-original="true" icon="download" />
            <span class="text">{{ $t('profile.signUp.main.moreDownloads') }}</span>
          </div>
          <div class="d-flex item">
            <Icon :as-original="true" icon="like-empty" />
            <span class="text">{{ $t('profile.signUp.main.favoriteDesigns') }}</span>
          </div>
          <div class="d-flex item">
            <Icon :as-original="true" icon="download" />
            <span class="text">{{ $t('profile.signUp.main.downloadHistory') }}</span>
          </div>
          <div class="d-flex item">
            <Icon :as-original="true" icon="like-empty" />
            <span class="text">{{ $t('profile.signUp.main.newProducts') }}</span>
          </div>
        </div>
      </div>
    </b-row>
  </b-col>
</template>

<script>
import Icon from 'UI/Icon';
export default {
  components: {
    Icon
  }
};
</script>

<style lang="scss" scoped>
.features-area {
  background-color: $lightGray;
  border-radius: 15px 0px 0px 15px;
}
.title {
  color: gray;
  height: 0;
  font-size: 1.5em;
  font-weight: 500;
}
.item {
  color: gray;
  font-size: 0.8em;
  font-weight: 400;
  .text {
    margin-left: 10px;
  }
}
</style>
